export const HEADER_TEXT_TITLE_ID = 'chat-widget-header-text';
export const HEADER_TEXT_DESCRIPTION_ID = 'chat-widget-header-description';